import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as homeActions from "../../../home/redux/actions"
import * as myAccountActions from '../../../my-account/redux/actions';
import * as serviceActions from '../../../pb-service-list/redux/actions';

import { KuposButton, KuposErrorSuccessModal, KuposInput } from '../../../common';
import React, { useState } from 'react';

import ApiUrls from '../../../../services/apiUrls';
import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import ThemeElevenTitle from '../components/ThemeElevenTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import { useTranslation } from 'react-i18next';

const initialState = {
	name: null,
	nameError: null, 
	email: null,
	emailError: null,
	affairs: null,
	affairsError: null,
	comment: null,
	commentError: null,
};

const ThemeElevenContact = ({ props, actions , operator}) => {
  const {t}= useTranslation("common");
	const [state, setState] = useState(initialState)
	const validate = () => {
		let errorCount = 0;
		if (!state.name) {
				setState({ ...state, nameError: true, nameErrorMessage: t("CONTACT.NAME_MESSAGE_ERROR") });
				errorCount++;
		} else if (!state.affairs) {
				setState({ ...state, affairsError: true, affairsErrorMessage: t("CONTACT.AFFAIRS_ERROR") });
				errorCount++;
		} else if (!state.email) {
				setState({ ...state, emailError: true, emailErrorMessage: t("CONTACT.EMAIL_ERROR") });
				errorCount++;
		} else if (state.email && !CommonService.isEMailValid(state.email)) {
				setState({ ...state, emailError: true, emailErrorMessage: t("CONTACT.EMAIL_ERROR") });
				errorCount++;
		} else if (!state.comment) {
				setState({
						...state,
						commentError: true,
						commentErrorMessage: t("CONTACT.COMMENT_ERROR"),
				});
				errorCount++;
		}

		if (errorCount > 0) {
				return false;
		} else {
				return true;
		}
};

	const onSubmit = () => {
		if (!validate()) {
				return;
		}
		let data = {
				name: state.name,
				email: state.email,
				affairs: state.affairs,
				comments: state.comment,
				operator_id: props.operator_id,
				operator_name: props.operator_name,
		};
	 actions
      .apiCall({
        url: AppData.BASE_URL + 'api/opsite_contact_info',
        method: 'POST',
        data,
      })
      .then(
        res => onContactInfoResponse(res),
        err => onContactInfoResponse(err),
      );
};

const onContactInfoResponse = res => {
		if (res && res.data && res.data.message) {
				setState({
						...state,
						showModal: true,
						responseMessage: res.data.message,
						status: res.data.status,
				});
		}
};

const onChange = (value, type) => {
	if (type == 'mobile') {
			value = CommonService.phoneNumberFormat(value);
			setState({
					...state,
					[type]: value,
					[type + 'Error']: false,
			});
	} else {
			setState({ ...state, [type]: value, [type + 'Error']: false });
	}
};

  return (
    <div className="themes-theme-eleven-contact ">
      <div style={{ position: 'relative', marginTop: '-41px' }}>
        <HeroSection heroImage={getIcons('contactBanner', operator)} />
      </div>
      <ThemeElevenTitle operator={operator} smallHeading=" " boldHeading={t("CONTACT.BOLD_HEADING")} />

      <div className="new-container-compact form-container mb15 mt10">
        <div class="contact-icons-set">
          <div class="contact-icon">
            <img alt="white-arrow" src={getIcons('mailIconContact', operator)} />
            <p class="text-bold font13">{t("CONTACT.EMAIL")}</p>
            <p class="font10">info@centropuerto.cl </p>
          </div>
          <div class="contact-icon">
            <img alt="white-arrow" src={getIcons('phoneIconContact', operator)} />
            <p class="text-bold font13">{t("CONTACT.TELEPHONE")}</p>
            <p class="font10">(+56 2) 2601 9883 // (+56 2) 2601 0549</p>
          </div>
        </div>
        <div className="card form-card">
          <KuposInput
            label={t("CONTACT.NAME_LABEL") }
            className="kupos-border"
            type="text"
            placeholder={t("CONTACT.NAME_PLACEHOLDER")}
            value={state.name}
            onChange={value => onChange(value, 'name')}
            error={!!state.nameError}
            errorMessage={state.nameErrorMessage}
          />
          <KuposInput
            label="Email"
            className="kupos-border"
            type="text"
            placeholder="example@gmail.com"
												value={state.email}
            onChange={value => onChange(value, 'email')}
            error={!!state.emailError}
            errorMessage={state.emailErrorMessage}
          />

          <KuposInput
            label={t("CONTACT.SUBJECT_LABEL")}
            className="kupos-border"
            type="text"
            placeholder={t("CONTACT.SUBJECT_PLACEHOLDER")}
            value={state.affairs}
            onChange={value => onChange(value, 'affairs')}
            error={!!state.affairsError}
            errorMessage={state.affairsErrorMessage}
          />
          <KuposInput
            label={t("CONTACT.MESSAGE_LABEL")}
            className="kupos-border"
            type="text"
            placeholder={t("CONTACT.MESSAGE_PLACEHOLDER")}
            value={state.comment}
            onChange={value => onChange(value, 'comment')}
            error={!!state.commentError}
            errorMessage={state.commentErrorMessage}
          />

          <div className="center-submit mt-20 font10" onClick={() => onSubmit()}>
            {/* <KuposButton title={'ENVIAR'} onPress={onSubmit} /> */}
            <KuposButton title="ENVIAR" >{t("CONTACT.SEND")}</KuposButton>
          </div>
										<KuposErrorSuccessModal
        			success={state.status == 200 ? true : false}
        			showModal={state.showModal}
        			onButtonClick={() => {
         	 setState({ showModal: false });
          	window.location.reload();
        }}
        bodyText={state.responseMessage}
      />
        </div>
      </div>
    </div>
  );
};
const onSubmit = () => {
  // if (isFormValid()) {
  //   return;
  // }
  // router.push('coupon-details');
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
				home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...homeActions  }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeElevenContact);


// WEBPACK FOOTER //
// ./src/features/themes/ThemeEleven/pages/ThemeElevenContact.js